(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["lg-faq"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var faqCardTitles = document.querySelectorAll('.faq-card__title');
    faqCardTitles.forEach(function(title) {
      title.addEventListener('click', function() {
        var body = this.nextElementSibling;
        var arrowBar = this.querySelector('.faq-card__arrow-bar');
        if (body.style.maxHeight) {
          body.style.maxHeight = null;
          body.classList.remove('open');
          arrowBar.style.transform = 'rotate(-180deg)';
        } else {
          body.style.maxHeight = body.scrollHeight + "px";
          body.classList.add('open');
          arrowBar.style.transform = 'rotate(0deg)';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-hero"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

// Function to create animated text lines
    function createAnimatedLines(textElement, className) {
      var lines = textElement.innerText.split('\n');
      textElement.innerHTML = ''; // Clear the original text
      lines.forEach(function(line, index) {
        var lineDiv = document.createElement('div');
        lineDiv.classList.add('hero-section__text-line');
        var lineElement = document.createElement(
          className === 'header'
            ? 'h1'
            : 'p'
        );
        lineElement.classList.add(
          className === 'header'
            ? 'hero-section__header-text'
            : 'hero-section__subheader-text'
        );
        lineElement.innerText = line;
        lineElement.style.animationDelay = 0.3 + index * 0.1 + 's'; // Staggered delay
        lineDiv.appendChild(lineElement);
        textElement.appendChild(lineDiv);
      });
    }

    var headerText = document.getElementById('hero-header-text');
    var subheaderText = document.getElementById('hero-subheader-text');
    createAnimatedLines(headerText, 'header');
    createAnimatedLines(subheaderText, 'subheader');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-social"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var images = document.querySelectorAll('.social-cta__image');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting === true) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold: [.35]});

    images.forEach(image => {
      observer.observe(image);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-testimonial"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var testimonials = document.querySelectorAll('.lg-testimonial-section__testimonial-content');

    var currentTestimonialIndex = 0;
    var nextTestimonialIndex = 1;
    testimonials[nextTestimonialIndex].style.display = 'none';

// Initialize first testimonial to be visible
    if (testimonials.length > 0) {
      testimonials[currentTestimonialIndex].style.display = 'flex';
      testimonials[currentTestimonialIndex].style.opacity = 1;
    }

    function cycleTestimonials() {

// Fade out the current testimonial
      testimonials[currentTestimonialIndex].style.opacity = 0;

// Wait for the fade-out transition, then switch to the next testimonial
      setTimeout(function() {
        testimonials[currentTestimonialIndex].style.display = 'none';
        currentTestimonialIndex = (currentTestimonialIndex + 1) % testimonials.length;
        testimonials[currentTestimonialIndex].style.display = 'flex';

// Short delay before starting the fade-in to ensure it's visible
        setTimeout(function() {
          testimonials[currentTestimonialIndex].style.opacity = 1;
        }, 10);
      }, 600); // Delay should match the CSS opacity transition time
    }

// Start cycling testimonials every 6 seconds
    setInterval(cycleTestimonials, 6000);
  });

  } catch(e) { console.error(e); }
})();

})();
